/**
 * Native Service - Native (mobil) ortama özel aksiyonlar
 *
 * bridge.isNative kontrolü çağıran tarafta yapılır.
 * Bu fonksiyonlar sadece native mesaj gönderir.
 *
 * Kullanım:
 *   import native from '@/mobile/mobile.fileHandler'
 *   if (bridge.isNative) {
 *     native.downloadFile(url, fileName, 'application/pdf')
 *   }
 */

import bridge from '../core/services/bridge.service';
import SecureLS from 'secure-ls';

const {
  createNativeDownloadRequest,
} = require('../core/services/api-url-policy');

/**
 * Dosya indir — DOWNLOAD_FILE mesajı gönderir (useDownload hook'u yakalar)
 */
export function downloadFile(url, fileName, mimeType) {
  const ls = new SecureLS({ encodingType: 'aes', isCompression: true });
  let token = null;

  try {
    token = ls.get('token');
  } catch (error) {
    token = null;
  }

  const request = createNativeDownloadRequest(
    url,
    process.env.VUE_APP_BACKEND_APP_URL,
    token
  );

  bridge.send('DOWNLOAD_FILE', {
    url: request.url,
    fileName,
    mimeType,
    headers: request.headers,
  });
}

/**
 * Dosya seç — PICK_FILE mesajı gönderir (useFilePicker hook'u yakalar)
 */
export function pickFile(accept) {
  bridge.send('PICK_FILE', { accept });
}

export default { downloadFile, pickFile };
